import { useQuery } from '@tanstack/react-query';
import { avatarService } from '@/api/services/avatar.service';
import { AvatarData } from '@/entities/avatar/avatar.entity';

export default function useAvatars() {
  async function getAvatars(): Promise<AvatarData> {
    return avatarService.getAvatars();
  }

  return useQuery({
    queryKey: [`avatars`],
    queryFn: getAvatars,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });
}
